import type { ReactNode } from 'react';
import type { TemplateSection } from '@nest-recruit/shared';
import { EMPTY } from '../../../lib/format';
import styles from './TemplateForms.module.css';

/** ADR 0083: a template read back, box by box (the request page, the job's ideal candidate). Empty boxes are left out. */
export function TemplateSectionsView({ sections }: { readonly sections: readonly TemplateSection[] }): ReactNode {
  if (sections.length === 0) return <p className={styles.empty}>{EMPTY}</p>;
  return (
    <div className={styles.sections}>
      {sections.map((section) => (
        <div key={section.box} className={styles.section}>
          <h4 className={styles.sectionTitle}>
            {section.number}. {section.title}
          </h4>
          <ul className={styles.lines}>
            {section.lines.map((line, index) => (
              <li key={`${index}-${line}`}>{line}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}

/**
 * ADR 0083: what was written before the templates (the four-part ideal candidate text, or the plans' free-text points), kept and
 * shown read-only. Nothing is deleted; new work goes into the template's boxes.
 */
export function WrittenBefore({ title, children }: { readonly title: string; readonly children: ReactNode }): ReactNode {
  return (
    <div className={styles.earlier}>
      <h4 className={styles.earlierTitle}>{title}</h4>
      {children}
    </div>
  );
}

export function EarlierText({ text }: { readonly text: string }): ReactNode {
  return <p className={styles.earlierText}>{text}</p>;
}
